import C2DRenderer from "./2d/C2DRenderer";
import GLRenderer from "./gl/GLRenderer";
import Stats from "./stats";

export default class Engine{
    constructor(id, passes){
        this.stats = new Stats();
        this.stats.showPanel( 0 ); 
        //document.body.appendChild( this.stats.dom );
        this.c2Drenderer = new C2DRenderer({engine: this});
        this.renderer = new GLRenderer( { engine: this, inCanvas: this.c2Drenderer.outCanvas, passes });


        document.getElementById("game").append(this.renderer.outCanvas);

        this.resize();
        window.addEventListener("resize", () => this.resize());

        this.time = {
            time: 0,
            delta: 0,
        }
        this.entities = [];
        this.destroyQueue = [];
        this.clearRender = true;
    }

    resize(){
        const factor = .9;
        this.width = window.innerWidth * factor;
        this.height = window.innerHeight * factor;
        [this.c2Drenderer ,this.renderer].forEach(r=>{
            r.resize(this.width, this.height);
        })

        this.scaleFactor = (window.innerHeight/1000) * factor;
    }

    destroyEntity(entity){
        this.destroyQueue.push(entity);
    }

    destroyQueueUpdate(){
        for(let i = this.entities.length - 1; i>=0 ;i--){
            if(this.destroyQueue.includes(this.entities[i])){
                this.entities[i] = null;
                this.entities.splice(i,1);
            }
        }
    }
    
    start(){
        const update = ()=>{
            this.stats.begin();

            let currentTime =  performance.now() / 1000;
            this.time.delta = currentTime - this.time.time;
            this.time.time = currentTime;

            this.entities.sort((a,b)=>a.zindex-b.zindex)
            this.entities.forEach(e=>e.update());
            this.destroyQueueUpdate();
          
            this.c2Drenderer.render(this.entities);
            this.renderer.render();

            this.stats.end();

            requestAnimationFrame(()=>update())
        }
        update();
    }
}